module.exports = __webpack_public_path__ + "static/media/web_02.5a16d2ac.webp";